import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import "./DattaDham.css";
import Header from "../components/Layout/Header";

// Dindori Images
import DindoriImg from "../assets/darbar.jpg";
import DindoriImg1 from "../assets/dindori_1.jpg";
import DindoriImg2 from "../assets/mauli_darbar.JPG";
import DindoriImg3 from "../assets/mauli_darbar1.JPG";

// Gurupeeth Images
import GurupeethImg from "../assets/gurupith.jpg";
import GurupeethImg1 from "../assets/trimbak.JPG";
import GurupeethImg2 from "../assets/SABHAMANDAP.jpg";
import GurupeethImg3 from "../assets/Swami_trimbak.JPG";
import GurupeethImg4 from "../assets/trimbak_nan.JPG";

// Gangapur Images
import GanagapurImg from "../assets/gangapur1.JPG";
import GangapurImg1 from "../assets/Gangapuram_1.JPG";
import GangapurImg4 from "../assets/gangapur nivas.jpg";

// Pithapur Images
import PithapurImg from "../assets/pithapur.jpg";
import PithapurImg1 from "../assets/pithapuram_1.JPG";
import PithapurImg2 from "../assets/pithapuram_2.JPG";
import PithapurImg3 from "../assets/pithapur02.JPG";

// Narsinhwadi Images
import NarsinhwadiImg from "../assets/narshinwadi1.JPG";
import NarsinhwadiImg1 from "../assets/wadi.JPG";
import NarsinhwadiImg2 from "../assets/wadi_swami.jpg";
import NarsinhwadiImg3 from "../assets/wadi_swami1.jpg";
import NarsinhwadiImg4 from "../assets/wadi_swami3.jpg";

const translations = {
  en: {
    header: "Seva Marg Datt Dham",
    home: "Home",
    aboutTitle: "About Seva Marg Datt Dham",
    howToReach: "How to Reach?",
    sections: [
      {
        title: "Shree Sadguru Dham Pradhan Kendra, Dindori, Maharashtra",
        desc: `For the past two decades, His Holiness Gurumauli has been executing a unique 18-point Rural Development Programme (RDP) from Shree Gurupeeth, Trimbakeshwar. This programme includes practical workshops, study tours, seminars, and training for all—free of cost—across India.

The aim is to nurture a new generation of Indians—rooted in culture, guided by science, and confident to face the future. Seva Marg has accomplished this to a great extent, earning recognition from hundreds of social and non-governmental organizations that have honoured His Holiness Gurumauli for these achievements.

Counselling sessions, which are essentially mind-healing techniques, operate across more than 5000 Dindori Pranit centres in India and abroad. They focus on the spiritual, social, educational, and ancestral background of the individual and offer simple, self-help techniques for overall well-being.

Over the last century, Dindori Pranit has transformed millions of lives—instilling values in youth, training farmers in organic and scientific agriculture, promoting communal harmony, conducting cancer research, organizing millions of no-dowry marriages, and helping countless people overcome addictions.`,
        images: [DindoriImg, DindoriImg1, DindoriImg2, DindoriImg3],
        hasReachButton: true,
        locationKey: "dindori",
      },
      {
        title: "Shree Gurupeeth Dham, Trimbakeshwar, Maharashtra",
        desc: `On 1st November 1992, Param Pujya Gurumauli laid the foundation stone of Shree Gurupeeth, taking the first step toward fulfilling Sadguru P.P. Moredada's dream of establishing a "Spiritual University."

This initiative grew through the selfless efforts of sevaks (volunteers) and the humble "One Rupee a Day" campaign, with funds offered at monthly satsangs. Through dedication, shramdaan (physical labor), and collective devotion, Shree Gurupeeth emerged after a decade of tireless work. Today, it stands as a living symbol of discipline, devotion, and sacrifice.

At Shree Swami Samarth Gurupeeth, the central darbar houses a lifelike idol of Shree Swami Samarth Maharaj seated on a Mayurasan (peacock throne). The Sabha Mandap and Darbar are built per vastu principles, radiating spiritual energy. The campus also includes memorials of Sadguru P.P. Moredada and Sadguru P.P. Pithale Maharaj, Vatvruksha temple, Yadnyabhoomi, Prasadalay, and a Vedic studies section with rare scriptures.

It also has a printing press, Ayurveda department, solar-powered Annachhatra (community dining hall), and facilities for Vedic and Ayurvedic education, therapy, and research.

Established on 1st November 1992 at Trimbakeshwar, it fulfills Sadguru Moredada's vision of spreading Swami Samarth Maharaj's teachings globally through seva, satsang, and welfare.`,
        images: [GurupeethImg, GurupeethImg1, GurupeethImg2, GurupeethImg3, GurupeethImg4],
        hasReachButton: true,
        locationKey: "trimbakeshwar",
      },
      {
        title: "Shree Ganagapur Datta Dham, Karnataka",
        desc: `In 1528, Shree Nrusinha Saraswati manifested at Karanja, Vidarbha per Lord Dattatreya's command.
He traveled across India for nearly a century and established sacred sites — Audumbar, Narsinhwadi, and Ganagapur.
He lived 12 years on Panchganga banks, alleviating the suffering of the poor, and guided countless souls at the Bhima–Amarja confluence in Ganagapur.
He left sacred Padukas for global welfare in 1678.
Shree Swami Samarth reassured devotees: "Never fear — I am always with you."
The tradition continued through Sadguru Narayandas Pithale (Nashik) and Sadguru Moredada (since 1976).
Param Pujya Gurumauli established 5,000+ seva centres and Shree Gurupeeth at Trimbakeshwar.
Datt Dham was established to preserve the spiritual–scientific tradition of Seva Marg.`,
        images: [GanagapurImg, GangapurImg1, GangapurImg4],
        hasReachButton: true,
        locationKey: "gangapur",
      },
      {
        title: "Shree Pithapuram Datt Dham, Andhra Pradesh",
        desc: `Birthplace of Shripad Shree Vallabh.
Devotees built: grand darbar, bhakt nivas (devotee lodging), annachhatra (community kitchen).
Datt centres expand spiritual, social, national welfare & environmental-conservation activities.
18 vibhags (departments) coordinate rural and urban development campaigns, domestic & international missions, and combined sadhana and seva experience for all volunteers and devotees.`,
        images: [PithapurImg, PithapurImg1, PithapurImg2, PithapurImg3],
        hasReachButton: true,
        locationKey: "pithapuram",
      },
      {
        title: "Shree Narsinhwadi Datt Dham, Maharashtra",
        desc: `Sacred tirtha due to Shree Nrusinha Saraswati Swami's holy presence.
Shree Swami Samarth gave diksha to Sadguru Pithale Maharaj here.
Devotees are building a magnificent darbar, bhakt nivas, and annachhatra.
Ensures every pilgrim experiences coordinated sadhana and seva.`,
        images: [NarsinhwadiImg, NarsinhwadiImg1, NarsinhwadiImg2, NarsinhwadiImg3, NarsinhwadiImg4],
        hasReachButton: true,
        locationKey: "narsinhwadi",
      },
    ],
    reachModals: {
      dindori: {
        title: "How to Reach Dindori Dham?",
        close: "Close",
        byAir: {
          title: "By Air",
          from: "From",
          to: "To",
          distance: "Distance",
          time: "Approx. Time",
          fromLocation: "Ozar Airport, Nashik",
          toLocation: "Dindori Sevamarg",
          distanceValue: "35 km",
          timeValue: "45 minutes",
        },
        byTrain: {
          title: "By Train",
          from: "From",
          to: "To",
          distance: "Distance",
          time: "Approx. Time",
          fromLocation: "Nashik Road Railway Station",
          toLocation: "Dindori Sevamarg",
          distanceValue: "28 km",
          timeValue: "40 minutes",
        },
        byBus: {
          title: "By Bus",
          busRoute: "Bus Route",
          from: "From",
          to: "To",
          distance: "Distance",
          time: "Approx. Time",
          routeNumber: "Route No. 210 (City Bus)",
          fromLocation: "Nashik Road Bus Stand",
          toLocation: "Dindori Sevamarg",
          distanceValue: "28 km",
          timeValue: "50 minutes",
        },
        byCar: {
          title: "By Car",
          description: "Navigate to Dindori Sevamarg using the map below:",
          openInMaps: "Open in Google Maps",
          mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3744.3194441085975!2d73.82603447419818!3d20.20404251559516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bdde7163a41ff99%3A0x64edb44c90abbccc!2sSri%20Swami%20Samarth%20Pradhan%20Seva%20Kendra!5e0!3m2!1sen!2sin!4v1760945825361!5m2!1sen!2sin",
          directMapUrl: "https://maps.app.goo.gl/WhNPhR37o5iTJv558",
        },
          contact: {
          title: "Contact Us",
          supportLabel: "Customer Support",
          phoneLabel: "Contact Number",
          phoneNumber: "9922420010",
        },
      },
      trimbakeshwar: {
        title: "How to Reach Trimbakeshwar Gurupeeth Dham?",
        close: "Close",
        byAir: {
          title: "By Air",
          from: "From",
          to: "To",
          distance: "Distance",
          time: "Approx. Time",
          fromLocation: "Nashik Airport (ISK)",
          toLocation: "Trimbakeshwar Gurupeeth",
          distanceValue: "30 km",
          timeValue: "40 minutes",
        },
        byTrain: {
          title: "By Train",
          from: "From",
          to: "To",
          distance: "Distance",
          time: "Approx. Time",
          fromLocation: "Nashik Road Railway Station",
          toLocation: "Trimbakeshwar Gurupeeth",
          distanceValue: "28 km",
          timeValue: "40 minutes",
        },
        byBus: {
          title: "By Bus",
          busRoute: "Bus Route",
          from: "From",
          to: "To",
          distance: "Distance",
          time: "Approx. Time",
          routeNumber: "Route No. 210 (City Bus)",
          fromLocation: "Nashik Road Bus Stand",
          toLocation: "Trimbakeshwar Gurupeeth",
          distanceValue: "28 km",
          timeValue: "50 minutes",
        },
        byCar: {
          title: "By Car",
          description: "Navigate to Trimbakeshwar Gurupeeth using the map below:",
          openInMaps: "Open in Google Maps",
          mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d30006.443897591907!2d73.5291!3d19.9326!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bddf4b167cecc65%3A0x3b8e4b5e1a81d285!2sAkhil%20Bhartiya%20Shree%20Swami%20Samarth%20Gurupeeth%2C%20Trimbakeshwar!5e0!3m2!1sen!2sin!4v1760945891221!5m2!1sen!2sin",
          directMapUrl: "https://maps.app.goo.gl/hz1R7j9spwmrGh4F6",
        },
          contact: {
          title: "Contact Us",
          supportLabel: "Customer Support",
          phoneLabel: "Contact Number",
          phoneNumber: "9922420010",
        },
      },
      gangapur: {
        title: "How to Reach Ganagapur Dham?",
        close: "Close",
        byAir: {
          title: "By Air",
          from: "Nearest Airport",
          to: "To",
          distance: "Distance",
          time: "Approx. Time",
          fromLocation: "Sholapur Airport (SSE)",
          alternativeLocation: "Alternative: Hyderabad Airport (HYD)",
          toLocation: "Ganagapur",
          distanceValue: "80 km from Sholapur / 280 km from Hyderabad",
          timeValue: "1.5 hrs / 5 hrs",
        },
        byTrain: {
          title: "By Train",
          from: "From",
          to: "To",
          distance: "Distance",
          time: "Approx. Time",
          fromLocation: "Solapur Railway Station",
          toLocation: "Ganagapur",
          distanceValue: "80 km",
          timeValue: "2 hours",
        },
        byBus: {
          title: "By Bus",
          routes: [
            {
              from: "From",
              to: "To",
              distance: "Distance",
              time: "Approx. Time",
              fromLocation: "Akkalkot",
              toLocation: "Ganagapur",
              distanceValue: "45 km",
              timeValue: "1 hour",
            },
            {
              from: "From",
              to: "To",
              distance: "Distance",
              time: "Approx. Time",
              fromLocation: "Solapur",
              toLocation: "Ganagapur",
              distanceValue: "80 km",
              timeValue: "2 hours",
            },
          ],
        },
        byCar: {
          title: "By Car",
          description: "Navigate to Ganagapur using the map below:",
          openInMaps: "Open in Google Maps",
          mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30494.229259410036!2d76.4923175793761!3d17.18097505151514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc89f116dbdc5cb%3A0xf33821667be90395!2sShri%20Swami%20Samartha%20Seva%20Kendra%20(Ghangapura)!5e0!3m2!1sen!2sin!4v1760946035579!5m2!1sen!2sin",
          directMapUrl: "https://maps.app.goo.gl/yrvTaTonq7BCPkrs6",
        },
          contact: {
          title: "Contact Us",
          supportLabel: "Customer Support",
          phoneLabel: "Contact Number",
          phoneNumber: "9922420010",
        },
      },
      pithapuram: {
        title: "How to Reach Pithapuram Dham?",
        close: "Close",
        byAir: {
          title: "By Air",
          from: "Nearest Airport",
          to: "To",
          distance: "Distance",
          time: "Approx. Time",
          fromLocation: "Rajahmundry Airport (RJA)",
          alternativeLocation: "Alternative: Visakhapatnam Airport (VTZ)",
          toLocation: "Pithapuram",
          distanceValue: "60 km from Rajahmundry / 120 km from Vizag",
          timeValue: "1 hr / 2.5 hrs",
        },
        byTrain: {
          title: "By Train",
          from: "From",
          to: "To",
          distance: "Distance",
          time: "Approx. Time",
          fromLocation: "Pithapuram Railway Station",
          toLocation: "Pithapuram Datt Kshetra",
          distanceValue: "Direct connectivity",
          timeValue: "Walking distance from station",
        },
        byBus: {
          title: "By Bus",
          routes: [
            {
              from: "From",
              to: "To",
              distance: "Distance",
              time: "Approx. Time",
              fromLocation: "Rajahmundry",
              toLocation: "Pithapuram",
              distanceValue: "60 km",
              timeValue: "1.5 hours",
            },
            {
              from: "From",
              to: "To",
              distance: "Distance",
              time: "Approx. Time",
              fromLocation: "Kakinada",
              toLocation: "Pithapuram",
              distanceValue: "35 km",
              timeValue: "1 hour",
            },
          ],
        },
        byCar: {
          title: "By Car",
          description: "Navigate to Pithapuram using the map below:",
          openInMaps: "Open in Google Maps",
          mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3813.110615238377!2d82.24153048885499!3d17.116102800000018!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a382ae8426b3767%3A0x470082f797aa9776!2sShri%20Swami%20Samarth%20Gurupeeth%20(Dindori%20Pranit)%20PITHAPURAM!5e0!3m2!1sen!2sin!4v1760947791730!5m2!1sen!2sin",
          directMapUrl: "https://maps.app.goo.gl/DWMiMJ3TXyzEZBdZ9",
        },
          contact: {
          title: "Contact Us",
          supportLabel: "Customer Support",
          phoneLabel: "Contact Number",
          phoneNumber: "9922420010",
        },
      },
      narsinhwadi: {
        title: "How to Reach Narsinhwadi Dham?",
        close: "Close",
        byAir: {
          title: "By Air",
          from: "Nearest Airport",
          to: "To",
          distance: "Distance",
          time: "Approx. Time",
          fromLocation: "Kolhapur Airport",
          alternativeLocation: "Alternative: Belgaum Airport",
          toLocation: "Narsinhwadi",
          distanceValue: "100 km from Kolhapur / 80 km from Belgaum",
          timeValue: "2 hrs / 1.5 hrs",
        },
        byTrain: {
          title: "By Train",
          from: "From",
          to: "To",
          distance: "Distance",
          time: "Approx. Time",
          fromLocation: "Miraj Junction Railway Station",
          toLocation: "Narsinhwadi",
          distanceValue: "90 km",
          timeValue: "2 hours by road",
        },
        byBus: {
          title: "By Bus",
          routes: [
            {
              from: "From",
              to: "To",
              distance: "Distance",
              time: "Approx. Time",
              fromLocation: "Kolhapur",
              toLocation: "Narsinhwadi",
              distanceValue: "100 km",
              timeValue: "2.5 hours",
            },
            {
              from: "From",
              to: "To",
              distance: "Distance",
              time: "Approx. Time",
              fromLocation: "Sangli",
              toLocation: "Narsinhwadi",
              distanceValue: "75 km",
              timeValue: "2 hours",
            },
          ],
        },
        byCar: {
          title: "By Car",
          description: "Navigate to Narsinhwadi using the map below:",
          openInMaps: "Open in Google Maps",
          mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3821.670633078621!2d74.59891517410747!3d16.693357422429617!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc0df1bfc7d9367%3A0x4101a33be41e7bde!2sAkhil%20Bhartiy%20Shree%20Swami%20Swami%20Samarth%20Dattadham%20%2C%20Shri%20Kshetra%20Nrusinhwadi%20(%20Dindori%20Pranit%20)!5e0!3m2!1sen!2sin!4v1760947306904!5m2!1sen!2sin",
          directMapUrl: "https://maps.app.goo.gl/C2rgLgw8T1SauWzg7",
        },
         contact: {
          title: "Contact Us",
          supportLabel: "Customer Support",
          phoneLabel: "Contact Number",
          phoneNumber: "9922420010",
        },
      },
    },
  },

  mr: {
    header: "दत्त धाम",
    home: "मुख्यपृष्ठ",
    aboutTitle: "दत्तधाम बद्दल",
    howToReach: "कसे पोहचायचे?",
    sections: [
      {
        title: "श्री सद्गुरुधाम, प्रधान केंद्र, दिंडोरी",
        desc: `गेल्या दोन दशकांपासून परम पूज्य गुरुमाऊली श्री गुरुपीठ, त्र्यंबकेश्वर येथून एक अद्वितीय १८ सूत्रीय ग्रामीण विकास कार्यक्रम (RDP) चालवित आहेत. या कार्यक्रमांतर्गत कार्यशाळा, अध्ययन दौरे, परिसंवाद आणि प्रशिक्षण सत्रे भारतभर विनामूल्य आयोजित केली जातात.

या उपक्रमाचा उद्देश असा भारतीय घडविणे आहे जो आपल्या संस्कृतीचा अभिमान बाळगतो, वैज्ञानिक दृष्टीकोन ठेवतो आणि आत्मविश्वासाने भविष्याचा सामना करू शकतो. सेवामार्गाने हे ध्येय मोठ्या प्रमाणात साध्य केले असून, शेकडो सामाजिक आणि स्वयंसेवी संस्थांनी परम पूज्य गुरुमाऊलींचा गौरव केला आहे.

मानसिक आणि आत्मिक उपचार म्हणून चालणाऱ्या समुपदेशन सत्रांची शृंखला भारत व विदेशातील ५००० हून अधिक दिंडोरी प्रणित केंद्रांमधून कार्यरत आहे. यात प्रत्येक व्यक्तीच्या आध्यात्मिक, सामाजिक, शैक्षणिक आणि कौटुंबिक पार्श्वभूमीचा विचार करून सुलभ आणि स्वयंसाध्य उपाय सुचवले जातात.

गेल्या १०० वर्षांत दिंडोरी प्रणित सेवामार्गाने लाखो जीवनांमध्ये आनंदाचा वर्षाव केला आहे — युवकांमध्ये संस्कार रुजविले, शेतकऱ्यांना सेंद्रिय शेती व आधुनिक कृषितंत्रांचे प्रशिक्षण दिले, समाजात सौहार्द व एकात्मता निर्माण केली, कर्करोगासारख्या व्याधींवर संशोधन केले, लाखो विवाह विनादहेज संपन्न केले आणि हजारो लोकांना व्यसनमुक्त जीवन दिले.`,
        images: [DindoriImg, DindoriImg1, DindoriImg2, DindoriImg3],
        hasReachButton: true,
        locationKey: "dindori",
      },
      {
        title: "श्री गुरुपीठ धाम, त्र्यंबकेश्वर, महाराष्ट्र",
        desc: `१ नोव्हेंबर १९९२ रोजी परम पूज्य गुरुमाऊलींनी श्री गुरुपीठाची पायाभरणी करून सद्गुरु परमपूज्य मोरेदादांच्या "आध्यात्मिक विद्यापीठ" स्थापनेच्या स्वप्नाची पूर्तता करण्याचा पहिला टप्पा पूर्ण केला.

या उपक्रमास सेवकांच्या निःस्वार्थ योगदानाने आणि "दररोज एक रुपया" या आगळ्या मोहिमेद्वारे मिळालेल्या निधीने बळ मिळाले. हजारो सेवकांच्या श्रमदानातून आणि भक्तीभावाने दशकभरात श्री गुरुपीठ उभे राहिले. आज ते शिस्त, श्रद्धा आणि त्यागाचे सजीव प्रतीक आहे.

श्री स्वामी समर्थ गुरुपीठाच्या दरबारात श्री स्वामी समर्थ महाराजांचा मयूरासनावर विराजमान असलेला सजीव भासणारा विग्रह आहे. वास्तुशास्त्रानुसार बांधलेले सभामंडप आणि दरबार दिव्य ऊर्जा प्रकट करतात. परिसरात सद्गुरु परमपूज्य मोरेदादा आणि सद्गुरु परमपूज्य पिठले महाराज यांच्या स्मृतीस्थळांसह वटवृक्ष मंदिर, यज्ञभूमी, प्रसादालय आणि वेदाध्ययन विभाग आहे.

येथे छापखाना, आयुर्वेद विभाग, सौरउर्जेवर चालणारे अन्नछत्र, वेद व आयुर्वेद शिक्षण, उपचार व संशोधन सुविधा आहेत.

१ नोव्हेंबर १९९२ रोजी त्र्यंबकेश्वर येथे स्थापन झालेला श्री गुरुपीठ, स्वामी समर्थ महाराजांच्या उपदेशांचा प्रसार सेवा, सत्संग व कल्याणाद्वारे जगभर करीत आहे.`,
        images: [GurupeethImg, GurupeethImg1, GurupeethImg2, GurupeethImg3, GurupeethImg4],
        hasReachButton: true,
        locationKey: "trimbakeshwar",
      },
      {
        title: "श्री गाणगापूर दत्तधाम, कर्नाटक",
        desc: `१५२८ मध्ये करंजा, विदर्भ येथे श्री नृसिंहसरस्वती अवतरले, श्री दत्तात्रेयांच्या वचनानुसार.
सुमारे १०० वर्ष भारतभ्रमण केले.
पवित्र तीर्थस्थाने स्थापिली: औदुंबर, नरसिंहवाडी, गाणगापूर.
पंचगंगा तीरावर १२ वर्षे राहून गरीबांचे दुःख दूर केले.
भीमा–अमरजा संगमस्थळी गाणगापूर येथे असंख्य जनांना मार्गदर्शन केले.
१६७८ मध्ये पवित्र पादुका जगकल्याणासाठी ठेवून गूढप्रस्थान केले.
श्री स्वामी समर्थ यांनी भक्तांना आश्वासन दिले: "कधीही घाबरू नका, मी सदैव सोबत आहे."
सद्गुरु नारायणदास पिठले (नाशिक) आणि सद्गुरु मोरेदाद (१९७६ पासून) यांनी परंपरा पुढे नेली.
परमपूज्य गुरुमाऊलींनी ५०००+ सेवा केंद्रे आणि त्र्यंबकेश्वर येथे श्री गुरुपीठ उभारले.
"दत्त धाम" सेवामार्गाची अध्यात्म–विज्ञानसंगत परंपरा टिकवण्यासाठी स्थापन केले गेले.`,
        images: [GanagapurImg, GangapurImg1, GangapurImg4],
        hasReachButton: true,
        locationKey: "gangapur",
      },
      {
        title: "श्री पिठापुरम दत्तधाम, आंध्रप्रदेश",
        desc: `श्रीपाद श्रीवल्लभांचे जन्मस्थान.
भक्तांच्या सेवेने उभारले: भव्य दरबार, भक्तनिवास, अन्नछत्र.
या दत्त केंद्रांचा उद्देश: आध्यात्मिक, सामाजिक, राष्ट्रीय कल्याण आणि पर्यावरण संवर्धन.
१८ विभागांद्वारे ग्राम व नागरी विकास अभियान, देश-विदेश अभियान, साधना व सेवा अनुभव प्रत्येक भक्तांपर्यंत पोहोचवला जातो.`,
        images: [PithapurImg, PithapurImg1, PithapurImg2, PithapurImg3],
        hasReachButton: true,
        locationKey: "pithapuram",
      },
      {
        title: "श्री क्षेत्र नरसिंहवाडी दत्तधाम, महाराष्ट्र",
        desc: `श्री नृसिंह सरस्वती स्वामींच्या पावन उपस्थितीमुळे पवित्र तीर्थस्थान.
येथे श्री स्वामी समर्थ यांनी सद्गुरु पिठले महाराजांना कार्यदीक्षा दिली.
भक्तांच्या योगदानातून उभारणी चालू आहे: भव्य दरबार, भक्तनिवास, अन्नछत्र.
प्रत्येक भाविकाला साधना व सेवांचा समन्वयित अनुभव मिळतो.`,
        images: [NarsinhwadiImg, NarsinhwadiImg1, NarsinhwadiImg2, NarsinhwadiImg3, NarsinhwadiImg4],
        hasReachButton: true,
        locationKey: "narsinhwadi",
      },
    ],
    reachModals: {
      dindori: {
        title: "दिंडोरी सेवामार्गाला कसे पोहचायचे?",
        close: "बंद करा",
        byAir: {
          title: "विमानाने",
          from: "येथून",
          to: "येथे",
          distance: "अंतर",
          time: "अंदाजे वेळ",
          fromLocation: "ओझर विमानतळ, नाशिक",
          toLocation: "दिंडोरी सेवामार्ग",
          distanceValue: "३५ कि.मी.",
          timeValue: "४५ मिनिटे",
        },
        byTrain: {
          title: "रेल्वेने",
          from: "येथून",
          to: "येथे",
          distance: "अंतर",
          time: "अंदाजे वेळ",
          fromLocation: "नाशिक रोड रेल्वे स्टेशन",
          toLocation: "दिंडोरी सेवामार्ग",
          distanceValue: "२८ कि.मी.",
          timeValue: "४० मिनिटे",
        },
        byBus: {
          title: "बसने",
          busRoute: "बस मार्ग",
          from: "येथून",
          to: "येथे",
          distance: "अंतर",
          time: "अंदाजे वेळ",
          routeNumber: "मार्ग क्र. २१० (सिटी बस)",
          fromLocation: "नाशिक रोड बस स्टँड",
          toLocation: "दिंडोरी सेवामार्ग",
          distanceValue: "२८ कि.मी.",
          timeValue: "५० मिनिटे",
        },
        byCar: {
          title: "कारने",
          description: "खालील नकाशा वापरून दिंडोरी सेवामार्गाला पोहचा:",
          openInMaps: "Google Maps मध्ये उघडा",
          mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3744.3194441085975!2d73.82603447419818!3d20.20404251559516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bdde7163a41ff99%3A0x64edb44c90abbccc!2sSri%20Swami%20Samarth%20Pradhan%20Seva%20Kendra!5e0!3m2!1sen!2sin!4v1760945825361!5m2!1sen!2sin",
          directMapUrl: "https://maps.app.goo.gl/WhNPhR37o5iTJv558",
        },
        contact: {
          title: "संपर्क साधा",
          supportLabel: "ग्राहक सेवा",
          phoneLabel: "संपर्क क्रमांक",
          phoneNumber: "9922420010",
        }
      },
      trimbakeshwar: {
        title: "त्र्यंबकेश्वर गुरुपीठाला कसे पोहचायचे?",
        close: "बंद करा",
        byAir: {
          title: "विमानाने",
          from: "येथून",
          to: "येथे",
          distance: "अंतर",
          time: "अंदाजे वेळ",
          fromLocation: "नाशिक विमानतळ (ISK)",
          toLocation: "त्र्यंबकेश्वर गुरुपीठ",
          distanceValue: "३० कि.मी.",
          timeValue: "४० मिनिटे",
        },
        byTrain: {
          title: "रेल्वेने",
          from: "येथून",
          to: "येथे",
          distance: "अंतर",
          time: "अंदाजे वेळ",
          fromLocation: "नाशिक रोड रेल्वे स्टेशन",
          toLocation: "त्र्यंबकेश्वर गुरुपीठ",
          distanceValue: "२८ कि.मी.",
          timeValue: "४० मिनिटे",
        },
        byBus: {
          title: "बसने",
          busRoute: "बस मार्ग",
          from: "येथून",
          to: "येथे",
          distance: "अंतर",
          time: "अंदाजे वेळ",
          routeNumber: "मार्ग क्र. २१० (सिटी बस)",
          fromLocation: "नाशिक रोड बस स्टँड",
          toLocation: "त्र्यंबकेश्वर गुरुपीठ",
          distanceValue: "२८ कि.मी.",
          timeValue: "५० मिनिटे",
        },
        byCar: {
          title: "कारने",
          description: "खालील नकाशा वापरून त्र्यंबकेश्वर गुरुपीठाला पोहचा:",
          openInMaps: "Google Maps मध्ये उघडा",
          mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d30006.443897591907!2d73.5291!3d19.9326!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bddf4b167cecc65%3A0x3b8e4b5e1a81d285!2sAkhil%20Bhartiya%20Shree%20Swami%20Samarth%20Gurupeeth%2C%20Trimbakeshwar!5e0!3m2!1sen!2sin!4v1760945891221!5m2!1sen!2sin",
          directMapUrl: "https://maps.app.goo.gl/hz1R7j9spwmrGh4F6",
        },
        contact: {
          title: "संपर्क साधा",
          supportLabel: "ग्राहक सेवा",
          phoneLabel: "संपर्क क्रमांक",
          phoneNumber: "9922420010",
        }
      },
      gangapur: {
        title: "गाणगापूर कसे पोहचायचे?",
        close: "बंद करा",
        byAir: {
          title: "विमानाने",
          from: "जवळचे विमानतळ",
          to: "येथे",
          distance: "अंतर",
          time: "अंदाजे वेळ",
          fromLocation: "शोलापूर विमानतळ (SSE)",
          alternativeLocation: "पर्याय: हैदराबाद विमानतळ (HYD)",
          toLocation: "गाणगापूर",
          distanceValue: "८० कि.मी. शोलापूरहून / २८० कि.मी. हैदराबादहून",
          timeValue: "१.५ तास / ५ तास",
        },
        byTrain: {
          title: "रेल्वेने",
          from: "येथून",
          to: "येथे",
          distance: "अंतर",
          time: "अंदाजे वेळ",
          fromLocation: "सोलापूर रेल्वे स्टेशन",
          toLocation: "गाणगापूर",
          distanceValue: "८० कि.मी.",
          timeValue: "२ तास",
        },
        byBus: {
          title: "बसने",
          routes: [
            {
              from: "येथून",
              to: "येथे",
              distance: "अंतर",
              time: "अंदाजे वेळ",
              fromLocation: "अक्कलकोट",
              toLocation: "गाणगापूर",
              distanceValue: "४५ कि.मी.",
              timeValue: "१ तास",
            },
            {
              from: "येथून",
              to: "येथे",
              distance: "अंतर",
              time: "अंदाजे वेळ",
              fromLocation: "सोलापूर",
              toLocation: "गाणगापूर",
              distanceValue: "८० कि.मी.",
              timeValue: "२ तास",
            },
          ],
        },
        byCar: {
          title: "कारने",
          description: "खालील नकाशा वापरून गाणगापूरला पोहचा:",
          openInMaps: "Google Maps मध्ये उघडा",
          mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30494.229259410036!2d76.4923175793761!3d17.18097505151514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc89f116dbdc5cb%3A0xf33821667be90395!2sShri%20Swami%20Samartha%20Seva%20Kendra%20(Ghangapura)!5e0!3m2!1sen!2sin!4v1760946035579!5m2!1sen!2sin",
          directMapUrl: "https://maps.app.goo.gl/yrvTaTonq7BCPkrs6",
        },
        contact: {
          title: "संपर्क साधा",
          supportLabel: "ग्राहक सेवा",
          phoneLabel: "संपर्क क्रमांक",
          phoneNumber: "9922420010",
        }
      },
      pithapuram: {
        title: "पिठापुरमला कसे पोहचायचे?",
        close: "बंद करा",
        byAir: {
          title: "विमानाने",
          from: "जवळचे विमानतळ",
          to: "येथे",
          distance: "अंतर",
          time: "अंदाजे वेळ",
          fromLocation: "राजमुंद्री विमानतळ (RJA)",
          alternativeLocation: "पर्याय: विशाखापट्टनम विमानतळ (VTZ)",
          toLocation: "पिठापुरम",
          distanceValue: "६० कि.मी. राजमुंद्रीहून / १२० कि.मी. विशाखापट्टनमहून",
          timeValue: "१ तास / २.५ तास",
        },
        byTrain: {
          title: "रेल्वेने",
          from: "येथून",
          to: "येथे",
          distance: "अंतर",
          time: "अंदाजे वेळ",
          fromLocation: "पिठापुरम रेल्वे स्टेशन",
          toLocation: "पिठापुरम दत्त क्षेत्र",
          distanceValue: "थेट कनेक्टिव्हिटी",
          timeValue: "स्टेशनपासून चालण्याचे अंतर",
        },
        byBus: {
          title: "बसने",
          routes: [
            {
              from: "येथून",
              to: "येथे",
              distance: "अंतर",
              time: "अंदाजे वेळ",
              fromLocation: "राजमुंद्री",
              toLocation: "पिठापुरम",
              distanceValue: "६० कि.मी.",
              timeValue: "१.५ तास",
            },
            {
              from: "येथून",
              to: "येथे",
              distance: "अंतर",
              time: "अंदाजे वेळ",
              fromLocation: "काकीनाडा",
              toLocation: "पिठापुरम",
              distanceValue: "३५ कि.मी.",
              timeValue: "१ तास",
            },
          ],
        },
        byCar: {
          title: "कारने",
          description: "खालील नकाशा वापरून पिठापुरमला पोहचा:",
          openInMaps: "Google Maps मध्ये उघडा",
          mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3813.110615238377!2d82.24153048885499!3d17.116102800000018!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a382ae8426b3767%3A0x470082f797aa9776!2sShri%20Swami%20Samarth%20Gurupeeth%20(Dindori%20Pranit)%20PITHAPURAM!5e0!3m2!1sen!2sin!4v1760947791730!5m2!1sen!2sin",
          directMapUrl: "https://maps.app.goo.gl/DWMiMJ3TXyzEZBdZ9",
        },
        contact: {
          title: "संपर्क साधा",
          supportLabel: "ग्राहक सेवा",
          phoneLabel: "संपर्क क्रमांक",
          phoneNumber: "9922420010",
        },
    },
      narsinhwadi: {
        title: "नरसिंहवाडीला कसे पोहचायचे?",
        close: "बंद करा",
        byAir: {
          title: "विमानाने",
          from: "जवळचे विमानतळ",
          to: "येथे",
          distance: "अंतर",
          time: "अंदाजे वेळ",
          fromLocation: "कोल्हापूर विमानतळ",
          alternativeLocation: "पर्याय: बेळगाव विमानतळ",
          toLocation: "नरसिंहवाडी",
          distanceValue: "१०० कि.मी. कोल्हापूरहून / ८० कि.मी. बेळगावहून",
          timeValue: "२ तास / १.५ तास",
        },
        byTrain: {
          title: "रेल्वेने",
          from: "येथून",
          to: "येथे",
          distance: "अंतर",
          time: "अंदाजे वेळ",
          fromLocation: "मिरज जंक्शन रेल्वे स्टेशन",
          toLocation: "नरसिंहवाडी",
          distanceValue: "९० कि.मी.",
          timeValue: "रस्त्याने २ तास",
        },
        byBus: {
          title: "बसने",
          routes: [
            {
              from: "येथून",
              to: "येथे",
              distance: "अंतर",
              time: "अंदाजे वेळ",
              fromLocation: "कोल्हापूर",
              toLocation: "नरसिंहवाडी",
              distanceValue: "१०० कि.मी.",
              timeValue: "२.५ तास",
            },
            {
              from: "येथून",
              to: "येथे",
              distance: "अंतर",
              time: "अंदाजे वेळ",
              fromLocation: "सांगली",
              toLocation: "नरसिंहवाडी",
              distanceValue: "७५ कि.मी.",
              timeValue: "२ तास",
            },
          ],
        },
        byCar: {
          title: "कारने",
          description: "खालील नकाशा वापरून नरसिंहवाडीला पोहचा:",
          openInMaps: "Google Maps मध्ये उघडा",
          mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3821.670633078621!2d74.59891517410747!3d16.693357422429617!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc0df1bfc7d9367%3A0x4101a33be41e7bde!2sAkhil%20Bhartiy%20Shree%20Swami%20Swami%20Samarth%20Dattadham%20%2C%20Shri%20Kshetra%20Nrusinhwadi%20(%20Dindori%20Pranit%20)!5e0!3m2!1sen!2sin!4v1760947306904!5m2!1sen!2sin",
          directMapUrl: "https://maps.app.goo.gl/C2rgLgw8T1SauWzg7",
        },
        contact: {
          title: "संपर्क साधा",
          supportLabel: "ग्राहक सेवा",
          phoneLabel: "संपर्क क्रमांक",
          phoneNumber: "9922420010",
        },
      },
    },
  },
};

export default function DattaDham() {
  const { lang } = useContext(LanguageContext);
  const t = translations[lang];

  const [currentImageIndexes, setCurrentImageIndexes] = useState(
    t.sections.map(() => 0)
  );

  const [activeModal, setActiveModal] = useState(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll('.scroll-animate');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndexes((prevIndexes) =>
        prevIndexes.map((idx, i) => {
          const sectionImages = t.sections[i].images;
          return (idx + 1) % sectionImages.length;
        })
      );
    }, 5000);
    return () => clearInterval(interval);
  }, [t.sections]);

  useEffect(() => {
    if (activeModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [activeModal]);

  const prevImage = (sectionIdx) => {
    setCurrentImageIndexes((prev) =>
      prev.map((idx, i) => {
        if (i === sectionIdx) {
          const sectionImages = t.sections[sectionIdx].images;
          return (idx - 1 + sectionImages.length) % sectionImages.length;
        }
        return idx;
      })
    );
  };

  const nextImage = (sectionIdx) => {
    setCurrentImageIndexes((prev) =>
      prev.map((idx, i) => {
        if (i === sectionIdx) {
          const sectionImages = t.sections[sectionIdx].images;
          return (idx + 1) % sectionImages.length;
        }
        return idx;
      })
    );
  };

  const handleModalClick = (e) => {
    if (e.target.className === "reach-modal-overlay") {
      setActiveModal(null);
    }
  };

  const renderModal = (locationKey) => {
  const modalData = t.reachModals[locationKey];
  if (!modalData) return null;

  return (
    <div className="reach-modal-overlay" onClick={handleModalClick}>
      <div className="reach-modal">
        <button
          className="modal-close-btn"
          onClick={() => setActiveModal(null)}
        >
          ✕
        </button>

        <h2 className="modal-title">{modalData.title}</h2>

        <div className="transport-grid">
          {/* By Air - COMPLETE */}
          <div className="transport-card">
            <div className="transport-icon air-icon">✈️</div>
            <h3>{modalData.byAir.title}</h3>
            <div className="transport-details">
              <p>
                <strong>{modalData.byAir.from}:</strong>{" "}
                {modalData.byAir.fromLocation}
              </p>
              {modalData.byAir.alternativeLocation && (
                <p style={{ fontSize: "0.9rem", color: "#666", fontStyle: "italic" }}>
                  {modalData.byAir.alternativeLocation}
                </p>
              )}
              <p>
                <strong>{modalData.byAir.to}:</strong>{" "}
                {modalData.byAir.toLocation}
              </p>
              <p>
                <strong>{modalData.byAir.distance}:</strong>{" "}
                {modalData.byAir.distanceValue}
              </p>
              <p>
                <strong>{modalData.byAir.time}:</strong>{" "}
                {modalData.byAir.timeValue}
              </p>
            </div>
          </div>

          {/* By Train - COMPLETE */}
          <div className="transport-card">
            <div className="transport-icon train-icon">🚂</div>
            <h3>{modalData.byTrain.title}</h3>
            <div className="transport-details">
              <p>
                <strong>{modalData.byTrain.from}:</strong>{" "}
                {modalData.byTrain.fromLocation}
              </p>
              <p>
                <strong>{modalData.byTrain.to}:</strong>{" "}
                {modalData.byTrain.toLocation}
              </p>
              <p>
                <strong>{modalData.byTrain.distance}:</strong>{" "}
                {modalData.byTrain.distanceValue}
              </p>
              <p>
                <strong>{modalData.byTrain.time}:</strong>{" "}
                {modalData.byTrain.timeValue}
              </p>
            </div>
          </div>

          {/* By Bus - COMPLETE */}
          <div className="transport-card">
            <div className="transport-icon bus-icon">🚌</div>
            <h3>{modalData.byBus.title}</h3>
            <div className="transport-details">
              {modalData.byBus.routes ? (
                <div className="bus-routes-grid">
                  {modalData.byBus.routes.map((route, idx) => (
                    <div key={idx} className="bus-route-column">
                      <p>
                        <strong>{route.from}:</strong> {route.fromLocation}
                      </p>
                      <p>
                        <strong>{route.to}:</strong> {route.toLocation}
                      </p>
                      <p>
                        <strong>{route.distance}:</strong> {route.distanceValue}
                      </p>
                      <p>
                        <strong>{route.time}:</strong> {route.timeValue}
                      </p>
                    </div>
                  ))}
                </div>
              ) : (
                <>
                  <p>
                    <strong>{modalData.byBus.busRoute}:</strong>{" "}
                    {modalData.byBus.routeNumber}
                  </p>
                  <p>
                    <strong>{modalData.byBus.from}:</strong>{" "}
                    {modalData.byBus.fromLocation}
                  </p>
                  <p>
                    <strong>{modalData.byBus.to}:</strong>{" "}
                    {modalData.byBus.toLocation}
                  </p>
                  <p>
                    <strong>{modalData.byBus.distance}:</strong>{" "}
                    {modalData.byBus.distanceValue}
                  </p>
                  <p>
                    <strong>{modalData.byBus.time}:</strong>{" "}
                    {modalData.byBus.timeValue}
                  </p>
                </>
              )}
            </div>
          </div>

          {/* By Car - COMPLETE */}
          <div className="transport-card car-card">
            <div className="transport-icon car-icon">🚗</div>
            <h3>{modalData.byCar.title}</h3>
            <p className="car-description">{modalData.byCar.description}</p>
            <div className="map-container">
              <iframe
                src={modalData.byCar.mapUrl}
                width="100%"
                height="250"
                style={{ border: 0, borderRadius: "8px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={`${locationKey} Location Map`}
              ></iframe>
            </div>
            <a
              href={modalData.byCar.directMapUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="open-maps-btn"
            >
              <span className="maps-icon">🗺️</span>
              {modalData.byCar.openInMaps}
            </a>
          </div>

          {/* Contact Us - COMPLETE */}
          <div className="transport-card contact-card">
            <div className="transport-icon contact-icon">📞</div>
            <h3>{modalData.contact.title}</h3>
            <div className="contact-details">
              <p className="support-label">{modalData.contact.supportLabel}</p>
              <a href={`tel:${modalData.contact.phoneNumber}`} className="phone-number">
                <span className="phone-icon">📱</span>
                {modalData.contact.phoneNumber}
              </a>
              <p className="contact-label">{modalData.contact.phoneLabel}</p>
            </div>
          </div>
        </div>

        <button
          className="modal-close-bottom"
          onClick={() => setActiveModal(null)}
        >
          {modalData.close}
        </button>
      </div>
    </div>
  );
};

  return (
    <div className="DattaDham-page">
      <div className="header-styled">
        <Header />
        <header className="DattaDham-header">
          <div className="header-center">
            <div className="breadcrumb">
              <Link to="/">{t.home}</Link> / <span>{t.header}</span>
            </div>
            <h1>{t.header}</h1>
          </div>
        </header>
      </div>

      <main className="DattaDham-main">
        <div className="container">
          <h2 className="section-title scroll-animate">{t.aboutTitle}</h2>

          {t.sections.map((sec, idx) => (
            <section
              key={idx}
              className={`DattaDham-section scroll-animate ${idx % 2 === 1 ? "reverse" : ""}`}
            >
              <div className="section-text">
                <h3>{sec.title}</h3>
                <p>{sec.desc}</p>
                
                {sec.hasReachButton && (
                  <button 
                    className="section-reach-button"
                    onClick={() => setActiveModal(sec.locationKey)}
                  >
                    <span className="reach-icon">📍</span>
                    {t.howToReach}
                  </button>
                )}
              </div>

              <div className="section-image">
                <button 
                  className="arrow left" 
                  onClick={() => prevImage(idx)}
                  aria-label="Previous image"
                >
                  ‹
                </button>
                <img
                  src={sec.images[currentImageIndexes[idx]]}
                  alt={`${sec.title} - Image ${currentImageIndexes[idx] + 1}`}
                />
                <button 
                  className="arrow right" 
                  onClick={() => nextImage(idx)}
                  aria-label="Next image"
                >
                  ›
                </button>
                <div className="image-counter">
                  {currentImageIndexes[idx] + 1} / {sec.images.length}
                </div>
              </div>
            </section>
          ))}
        </div>
      </main>

      {activeModal && renderModal(activeModal)}
    </div>
  );
}